// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1xhK7","closeIcon":"_1D4so","header":"_2qpd9","content":"vkOnI","scrollable":"_2_nGo","footer":"_261cQ"};